import { WYATTElement } from "wyatt";
import { registerComponent, debounce } from "helpers";

registerComponent(
  "back-to-top",
  class BackToTop extends WYATTElement {
    constructor() {
      super();

      this.lastScrollPosition = 0;
      this.onScrollHandler = debounce(this.handleScroll.bind(this), 300);
    }

    connectedCallback() {
      if (
        document.body.offsetHeight / document.documentElement.clientHeight <
        4
      ) {
        return;
      }

      window.addEventListener("scroll", this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    handleScroll() {
      const currentScrollPosition = window.scrollY;

      if (
        currentScrollPosition < this.lastScrollPosition &&
        currentScrollPosition > 100
      ) {
        this.setAttribute("back-to-top-visible", "true");
        this.removeAttribute("aria-hidden");
      } else {
        this.setAttribute("back-to-top-visible", "false");
        this.setAttribute("aria-hidden", "true");
      }

      this.lastScrollPosition = currentScrollPosition;
    }
  }
);
